import { render, staticRenderFns } from "./surface_post.vue?vue&type=template&id=09880614&scoped=true&"
import script from "./surface_post.vue?vue&type=script&lang=js&"
export * from "./surface_post.vue?vue&type=script&lang=js&"
import style0 from "./surface_post.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./surface_post.vue?vue&type=style&index=1&id=09880614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09880614",
  null
  
)

export default component.exports